import React from "react";
import { motion } from "framer-motion";
import { Heart, ArrowUpRight, Users } from "lucide-react";
import Modal from "../../../components/common/Modal";
import VoterAvatars from "./VoterAvatars";

const ProfileDetailModal = ({
  selectedIdea,
  onClose,
  handleVote,
  votedIdeas,
  showToast,
}) => {
  const headerContent = (
    <div>
      <motion.h2
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3, duration: 0.4 }}
        className="tw-text-2xl tw-font-bold tw-bg-gradient-to-r tw-from-gray-900 tw-to-gray-600 tw-bg-clip-text tw-text-transparent"
      >
        {selectedIdea.name}
      </motion.h2>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.4 }}
        className="tw-flex tw-items-center tw-space-x-2 tw-mt-2"
      >
        <span className="tw-text-sm tw-text-gray-500">
          發佈者 {selectedIdea.author || "匿名"}
        </span>
      </motion.div>
    </div>
  );

  return (
    <Modal onClose={onClose} headerContent={headerContent} maxHeight="80vh">
      {selectedIdea.images && selectedIdea.images.length > 0 && (
        <div className="tw-mb-6 tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4">
          {selectedIdea.images.map((image, index) => (
            <div
              key={index}
              className="tw-rounded-xl tw-overflow-hidden tw-h-64"
            >
              <img
                src={image}
                alt={`${selectedIdea.name} - 圖片 ${index + 1}`}
                className="tw-w-full tw-h-full tw-object-cover"
              />
            </div>
          ))}
        </div>
      )}

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.5, duration: 0.4 }}
        className="tw-mb-8 tw-pr-2"
      >
        {selectedIdea.description ? (
          <p className="tw-text-gray-600 tw-whitespace-pre-line">
            {selectedIdea.description}
          </p>
        ) : (
          <p className="tw-text-gray-400 tw-italic">未提供描述</p>
        )}
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.6, duration: 0.4 }}
        className="tw-flex tw-flex-col tw-space-y-4"
      >
        <div className="tw-flex tw-justify-between tw-items-center">
          <div className="tw-flex tw-items-center tw-space-x-4">
            <motion.button
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
              onClick={() => handleVote(selectedIdea.id)}
              className="tw-flex tw-items-center tw-space-x-2 tw-px-4 tw-py-2 tw-rounded-full tw-bg-rose-50 hover:tw-bg-rose-100 tw-transition-colors"
            >
              <Heart
                className={`tw-w-5 tw-h-5 ${
                  votedIdeas.has(selectedIdea.id)
                    ? "tw-fill-rose-500 tw-text-rose-500"
                    : "tw-text-rose-500"
                }`}
              />
              <span className="tw-font-medium tw-text-rose-500">
                {selectedIdea.votes} 票
              </span>
            </motion.button>

            <button
              onClick={(e) => {
                e.stopPropagation();
                navigator.clipboard.writeText(
                  `https://sotravel.com/inferno?search=${selectedIdea.name}`
                );
                showToast("已複製個人資料連結！", "success");
              }}
              className="tw-flex tw-items-center tw-space-x-2 tw-px-4 tw-py-2 tw-rounded-full tw-bg-rose-50 hover:tw-bg-rose-100 tw-transition-colors tw-text-gray-500"
            >
              <span>分享個人資料</span>
              <ArrowUpRight className="tw-w-5 tw-h-5" />
            </button>
          </div>
        </div>

        {selectedIdea.voters && selectedIdea.voters.length > 0 && (
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.7 }}
            className="tw-bg-gray-50 tw-rounded-xl tw-p-4"
          >
            <div className="tw-flex tw-items-center tw-space-x-3 tw-mb-3">
              <Users className="tw-w-5 tw-h-5 tw-text-gray-500" />
              <span className="tw-font-medium tw-text-gray-700">支持者</span>
            </div>
            <VoterAvatars voters={selectedIdea.voters} maxDisplay={8} />
            {selectedIdea.voters.length > 8 && (
              <p className="tw-text-sm tw-text-gray-500 tw-mt-2">
                還有 {selectedIdea.voters.length - 8} 位支持者
              </p>
            )}
          </motion.div>
        )}
      </motion.div>
    </Modal>
  );
};

export default ProfileDetailModal;
